import { PRODUCT_TYPE } from "pages/AccountSettlementHistoryOrderId/constants/ProductType";

type GetProductTypeInput = {
  productType: string;
};

type GetProductTypeOutput = (typeof PRODUCT_TYPE)[keyof typeof PRODUCT_TYPE];

export const getProductType = (
  product: GetProductTypeInput
): GetProductTypeOutput => {
  const { productType } = product;
  if (productType === "ticket") return PRODUCT_TYPE.TICKET;
  return PRODUCT_TYPE.GOODS;
};
